import IJobSiteAdvanceSearch from '../types/JobSiteAdvanceSearch';

export default {
  searchType: 'ProfileAndCV',
} as IJobSiteAdvanceSearch;
